import React from 'react';
import styles from './DocumentationFolderPickerItem.module.scss';
import { DocumentationFolder } from '../../../../graphql/graphql';

interface Props {
	onSelect: (id: string) => void;
	item: DocumentationFolder;
}

const DocumentationFolderPickerItem: React.FC<Props> = ({ item, onSelect }) => {
	return (
		<div className={styles.item} onClick={() => onSelect(item.id)}>
			<img src={'/dist/icons/folder-solid.svg'} alt='Folder icon' />
			<div>
				{item.name} ({item.filesCount})
			</div>
		</div>
	);
};

export default DocumentationFolderPickerItem;
